function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGameXbox = function SvgGameXbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 20c-1.5-.1-3-.7-4.3-1.5-1-.7-1.3-1-1.3-1.6 0-1.1 1.3-3.1 3.5-5.4 1.2-1.3 3-2.9 3.1-2.8.4 0 3.2 2.9 4.3 4.2 1.7 2 2.5 3.8 2.1 4.6-.3.5-2.2 1.7-3.5 2.1-1.2.4-2.7.5-4 .4Zm-7-4.3a10 10 0 0 1-1.6-4.6l.2-2.3A9.5 9.5 0 0 1 2.7 4c.5-.5.5-.5 1.1-.3.7.3 1.5.8 2.6 1.8l.7.7-.3.4a29.7 29.7 0 0 0-4.3 7c-.4 1-.5 2.1-.4 2.5.1.3 0 .2-.3-.3Zm15.6.3c.1-.4 0-1.2-.3-2-.5-1.8-2.4-5-4.2-7.2l-.5-.6.6-.6 1.9-1.5c.4-.3 1-.5 1.4-.5.1 0 .8.6 1.2 1.3a10 10 0 0 1 1.6 3.7c.2.9.2 2.8 0 3.6 0 .7-.4 1.7-.6 2.3l-1 1.7c-.1.1-.1.1 0-.2ZM9 3.3c-.8-.4-2-.9-2.7-1a5 5 0 0 0-.9 0c-.6 0-.5 0 .4-.5a9.3 9.3 0 0 1 5.9-.7c1 .2 2.2.6 2.9 1l.2.2h-.5c-.9-.1-2.2.3-3.6 1l-.9.3-.8-.3Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgGameXbox;